import { useRouter, useNuxtApp } from "nuxt/app";
import { ref } from "vue";
function stripUndefined(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([k, v]) => v !== void 0)
  );
}
export const useAisRouter = () => {
  const router = useRouter();
  const app = useNuxtApp();
  const algoliaRouter = ref({
    router: {
      read() {
        const query = router.currentRoute.value.query;
        const normalizedQuery = Array.isArray(query) ? query[0] : query;
        return stripUndefined(normalizedQuery);
      },
      write(routeState) {
        const currentQueryState = this.read();
        if (JSON.stringify(currentQueryState) === JSON.stringify(stripUndefined(routeState))) {
          return;
        }
        router.push({
          query: { ...currentQueryState, ...stripUndefined(routeState) }
        });
      },
      createURL(routeState) {
        return router.resolve({
          // @ts-ignore see comment above
          query: routeState
        }).href;
      },
      onUpdate(cb) {
        if (typeof window === "undefined") return;
        this._removeAfterEach = router.afterEach((to, from) => {
          if (to.path === from.path) cb(this.read());
        });
        app.hook("page:finish", () => {
          cb(this.read());
        });
      },
      dispose() {
        if (typeof window === "undefined") {
          return;
        }
        if (this._removeAfterEach) {
          this._removeAfterEach();
        }
      }
    }
  });
  return algoliaRouter;
};
